import { useSelector } from "react-redux";

export function useTable() {
  return useSelector((state) => state.table);
}
